import script from "./Industry.vue?vue&type=script&lang=ts&setup=true"
export * from "./Industry.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__